// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dialog-module__ui-Dialog--lw1hY {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 10;
}
.Dialog-module__ui-Dialog-Dim--Ot8V2 {
  width: 100%;
  height: 100%;
  background: rgba(9, 10, 12, 0.72);
}

.Dialog-module__ui-Dialog-Container--_tEYU {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
  background: var(--chaek-color-surface-canvas);
  border-radius: 22px;
  padding: 24px;
}

.Dialog-module__ui-Dialog-Close--cCyLp {
  position: absolute;
  top: 24px;
  right: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 15px;
  color: var(--chaek-color-text-primary);
  font-family: var(--chaek-font-family-pretendard);
  font-size: 20px;
  line-height: 30px;
  letter-spacing: -0.4492px;
}

.Dialog-module__ui-Dialog-Close--cCyLp::before {
  content: '×';
}

.Dialog-module__ui-Dialog-Close--cCyLp img {
  display: none;
}

.Dialog-module__ui-Dialog-Header--OGaWN {
  min-height: 44px;
  padding-right: 56px;
}

.Dialog-module__title--N_V5w {
  color: var(--chaek-color-text-primary);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 21px;
  font-weight: 400;
  line-height: 31.5px;
  letter-spacing: -1.0589px;
}

.Dialog-module__sub-title--BXxlV {
  padding-top: 16px;
  color: var(--chaek-color-text-primary);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.7625px;
}

.Dialog-module__ui-Dialog-Body--G8z7V {
  color: var(--chaek-color-text-primary);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.7625px;
  padding-top: 20px;
}

.Dialog-module__ui-Dialog-Footer--AXz0s {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 20px;
}

.Dialog-module__ui-Dialog-Container--_tEYU {
  color: var(--chaek-color-text-primary);
}

.Dialog-module__size-medium--EQe0m .Dialog-module__ui-Dialog-Container--_tEYU {
  width: 358px;
}

.Dialog-module__size-large--TMJsq .Dialog-module__ui-Dialog-Container--_tEYU {
  width: 760px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Dialog/Dialog.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,6CAA6C;EAC7C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,gDAAgD;EAChD,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,iDAAiD;EACjD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,iDAAiD;EACjD,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,iDAAiD;EACjD,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".ui-Dialog {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 10;\n}\n.ui-Dialog-Dim {\n  width: 100%;\n  height: 100%;\n  background: rgba(9, 10, 12, 0.72);\n}\n\n.ui-Dialog-Container {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  box-sizing: border-box;\n  background: var(--chaek-color-surface-canvas);\n  border-radius: 22px;\n  padding: 24px;\n}\n\n.ui-Dialog-Close {\n  position: absolute;\n  top: 24px;\n  right: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 15px;\n  color: var(--chaek-color-text-primary);\n  font-family: var(--chaek-font-family-pretendard);\n  font-size: 20px;\n  line-height: 30px;\n  letter-spacing: -0.4492px;\n}\n\n.ui-Dialog-Close::before {\n  content: '×';\n}\n\n.ui-Dialog-Close img {\n  display: none;\n}\n\n.ui-Dialog-Header {\n  min-height: 44px;\n  padding-right: 56px;\n}\n\n.title {\n  color: var(--chaek-color-text-primary);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 21px;\n  font-weight: 400;\n  line-height: 31.5px;\n  letter-spacing: -1.0589px;\n}\n\n.sub-title {\n  padding-top: 16px;\n  color: var(--chaek-color-text-primary);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.7625px;\n}\n\n.ui-Dialog-Body {\n  color: var(--chaek-color-text-primary);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.7625px;\n  padding-top: 20px;\n}\n\n.ui-Dialog-Footer {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-top: 20px;\n}\n\n.ui-Dialog-Container {\n  color: var(--chaek-color-text-primary);\n}\n\n.size-medium .ui-Dialog-Container {\n  width: 358px;\n}\n\n.size-large .ui-Dialog-Container {\n  width: 760px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Dialog": `Dialog-module__ui-Dialog--lw1hY`,
	"ui-Dialog-Dim": `Dialog-module__ui-Dialog-Dim--Ot8V2`,
	"ui-Dialog-Container": `Dialog-module__ui-Dialog-Container--_tEYU`,
	"ui-Dialog-Close": `Dialog-module__ui-Dialog-Close--cCyLp`,
	"ui-Dialog-Header": `Dialog-module__ui-Dialog-Header--OGaWN`,
	"title": `Dialog-module__title--N_V5w`,
	"sub-title": `Dialog-module__sub-title--BXxlV`,
	"ui-Dialog-Body": `Dialog-module__ui-Dialog-Body--G8z7V`,
	"ui-Dialog-Footer": `Dialog-module__ui-Dialog-Footer--AXz0s`,
	"size-medium": `Dialog-module__size-medium--EQe0m`,
	"size-large": `Dialog-module__size-large--TMJsq`
};
export default ___CSS_LOADER_EXPORT___;
